import { store } from '../index'

function setMainTypeAct(mainType) {
    return {
        type: "SET_MAINTYPE",
        mainType: mainType
    }
}

export const setMainType = (mainType) => {
    return store.dispatch(setMainTypeAct(mainType))
}

function setColorAct(color) {
    return {
        type: "SET_COLOR",
        color: color
    }
}

export const setColor = (color) => {
    return store.dispatch(setColorAct(color))
}

function setShapeAct(shape) {
    return {
        type: "SET_SHAPE",
        shape: shape
    }
}

export const setShape = (shape) => {
    return store.dispatch(setShapeAct(shape))
}

function setSizeAct(size) {
    return {
        type: "SET_SIZE",
        size: size
    }
}

export const setSize = (size) => {
    return store.dispatch(setSizeAct(size))
}

function setAgacCaliAct(agacCali) {
    return {
        type: "SET_AGACCALI",
        agacCali: agacCali
    }
}

export const setAgacCali = (agacCali) => {
    return store.dispatch(setAgacCaliAct(agacCali))
}

function setYaprakTipiAct(yaprakTipi) {
    return {
        type: "SET_YAPRAKTIPI",
        yaprakTipi: yaprakTipi
    }
}

export const setYaprakTipi = (yaprakTipi) => {
    return store.dispatch(setYaprakTipiAct(yaprakTipi))
}

function setYaprakSekliAct(yaprakSekli) {
    return {
        type: "SET_YAPRAKSEKLI",
        yaprakSekli: yaprakSekli
    }
}

export const setYaprakSekli = (yaprakSekli) => {
    return store.dispatch(setYaprakSekliAct(yaprakSekli))
}




